<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Role</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a routerLink="/home" (click)="SetInactive()">Home</a></li>
            <li class="breadcrumb-item active">Role</li>
          </ol>
        </div>
      </div>
    </div><!-- /.container-fluid -->
  </section>

  <!-- Main content -->
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card card-primary card-outline">
            <div class="card-header">
              <h3 class="card-title" style="padding-top: 5px;">
                <i class="fas fa-user-tag"></i>
                Role
              </h3>
              <button type="button" #btnModalOpen class="btn btn-primary btn-sm float-right" data-toggle="modal" data-target="#createRoleModal" (click)="cancel()">
                <i class="fas fa-plus-circle"></i> Create Role
              </button>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <table #dataTable class="table table-bordered table-striped" style="width: 100%;">
              </table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
  </section>
  <!-- /.content -->

  <div class="modal fade" id="createRoleModal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{header}}</h4>
                <button #btnClose type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="roleForm" (ngSubmit)= "saveRole()">
                <div class="modal-body">
                  <div class="card-body row">
                    <div class="col-6 form-group">
                        <label for="RoleName">Role Name</label>
                        <input type="text" [ngClass]="{ 'is-invalid': roleForm.get('RoleName').errors && roleForm.get('RoleName').touched }" class="form-control" placeholder="Role Name" formControlName="RoleName">
                        <div class="invalid-feedback" *ngIf="roleForm.get('RoleName').errors && roleForm.get('RoleName').touched">You can't leave this empty.</div>
                    </div>
                    <div class="col-6 form-group">
                        <label for="IndexPage">Index Page</label>
                        <select [ngClass]="{ 'is-invalid': roleForm.get('IndexPage').errors && roleForm.get('IndexPage').touched }" class="form-control" formControlName="IndexPage">
                            <option value="">Select Please ...</option>
                            <option value="/home/profile">/home/profile</option>
                            <option *ngFor="let indx of indexes" [value]="indx.nvPageUrl">{{indx.nvPageUrl}}</option>
                        </select>
                        <div class="invalid-feedback" *ngIf="roleForm.get('IndexPage').errors && roleForm.get('IndexPage').touched">You can't leave this empty.</div>
                    </div>
                    <div class="col-12 form-group">
                      <label for="MenuPermission">Menu Permission</label>
                      <table class="display table table-bordered table-striped" style="width:100%">
                        <thead>
                          <tr>
                            <th>Sl#</th>
                            <th>Menu</th>
                            <th style="text-align: center;">Action</th>
                          </tr>
                        </thead>
                        <tbody formArrayName="MenuPermission">
                          <tr *ngFor="let mn of MenuPermission.controls; let i=index" [formGroupName]="i">
                            <td>{{mn.value.Index}}</td>
                            <td>{{mn.value.NameWithParent}}</td>
                            <td style="text-align: center;">
                              <input type="checkbox" formControlName ="IsChecked">
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-default" data-dismiss="modal">
                      <i class="fas fa-window-close"></i>
                      Close
                    </button>
                    <button type="submit" class="btn btn-primary">
                      <i class="fas fa-save"></i>
                      Save
                    </button>
                </div>
            </form>
        </div>
    </div>
  </div>
</div>